import React, { useState, useEffect } from "react";
import { isIOS } from "react-device-detect";
import { labels, list_of_Options } from "./constant";
import Modal from "../../../Common/ModalWithEffects";
import AnimatedTimer from "./AnimatedTimer";
import warning from "../../../../images/warning.png";
import Loader from "react-loader-spinner";

const PaymentOptionForAndroid = ({
  setScreen,
  data,
  ObjHttpApiUtil,
  pageTimer,
  checkStatus,
  getUpiLink,
  redirectLink,
  showUpiCollect,
  clearVpa
}) => {
  const [showUpiTimerPage, setShowUpitimerPage] = useState(false);
  const [showCancelTimerPage, setShowCancelTimerPage] = useState(false);
  const [openingUpiApp, updateOpeningUpiApp] = useState(false);
  const [failedToGetDeeplink, setFailedToGetDeeplink] = useState(false);
  const [appName, setAppOpened] = useState("");

  const redirectUPI = (link) => {
    clearVpa(true);
    window.open(link, "_top");
    setShowUpitimerPage(true);
    updateOpeningUpiApp(false);
  };

  useEffect(() => {
    if (redirectLink) {
      redirectUPI(redirectLink);
    }
    if (data.isFailure) {
      setFailedToGetDeeplink(true);
      updateOpeningUpiApp(false);
    }
  }, [redirectLink, data]);

  const getUpiApps = () => {
    return (
      <div className="logos">
        {list_of_Options.map((item) => {
          return (
            <img
              onClick={() => {
                updateOpeningUpiApp(true);
                setAppOpened(item.name);
                if (redirectLink && appName === item.name) {
                  redirectUPI(redirectLink);
                } else {
                  getUpiLink(true, item.prefix);
                }
              }}
              alt={item.name}
              src={item.source}
            />
          );
        })}
      </div>
    );
  };

  const showTimer = (showUpiTimer) => {
    if (showUpiTimer)
      return (
        <Modal>
          <AnimatedTimer
            transactionId={data.pine_pg_transaction_id}
            timer={pageTimer}
            setScreen={setScreen}
            ObjHttpApiUtil={ObjHttpApiUtil}
            checkStatus={checkStatus}
          />
          <hr className="horizontalRule" />
          <div className="cancelUpiPaymentContainer">
            <div className="tryWithAnotherAppText">
              {labels.TRY_WITH_ANOTHER_UPI_APP}
            </div>
            <div
              className="cancelPaymentText"
              onClick={() => {
                setShowCancelTimerPage(true);
              }}
            >
              {labels.CANCEL_PAYMENT}
            </div>
          </div>
        </Modal>
      );
  };

  return (
    <>
      <h1 className="heading mt-3">{!isIOS ? "UPI" : "UPI Apps"}</h1>
      {!isIOS ? (
        <div className="QR_container">
          <div className="UPIicons UpiManyMoreText">
            {labels.SUPPORTED_UPI_APP}
          </div>
          <button
            onClick={() => {
              updateOpeningUpiApp(true);
              setAppOpened(labels.PAY_WITH_UPI_APP);
              if (redirectLink && appName === labels.PAY_WITH_UPI_APP) {
                redirectUPI(redirectLink);
              } else {
                getUpiLink(true);
              }
            }}
            className="generate-qr-code"
          >
            {labels.PAY_WITH_UPI_APP}
          </button>
        </div>
      ) : null}
      {!isIOS && <h1 className="heading mt-3">{labels.UPI_APP}</h1>}
      {getUpiApps()}
      {showUpiCollect && (
        <>
          <h1 className="heading mb-0 mt-2">Pay with UPI ID</h1>
          <p className="instruction">
            You will receive a payment request on the enterd UPI ID
          </p>
        </>
      )}

      {openingUpiApp ? (
        <Modal>
          <div className="appOpeningModalTitle">{labels.OPENING_APP}</div>
          <Loader
            type="Oval"
            color="var(--primary-theme-color)"
            height={20}
            width={30}
          />
        </Modal>
      ) : null}

      {failedToGetDeeplink ? (
        <Modal
          showCancelButton={true}
          setIsCancelPopup={setFailedToGetDeeplink}
        >
          <div className="failedModalTitle">{labels.FAILED_TO_OPEN_APP}</div>
          <div className="failedModalBody">{labels.PROCESS_PAYMENT_ERROR}</div>
        </Modal>
      ) : null}

      {showTimer(showUpiTimerPage)}
      {showCancelTimerPage ? (
        <Modal
          showCancelButton={true}
          setIsCancelPopup={setShowCancelTimerPage}
        >
          <img src={warning} alt="warningCircle" width="48px" height="48px" />
          <p className="popUp-title">{labels.CANCEL_PAYMENT}</p>
          <p className="popUp-body">{labels.CANCEL_PAYMENT_TEXT}</p>
          <button
            className="popUp-accept-button"
            onClick={() => {
              setShowCancelTimerPage(false);
              setShowUpitimerPage(false);
            }}
          >
            {labels.YES_CANCEL}
          </button>
          <button
            className="popUp-reject-button"
            onClick={() => setShowCancelTimerPage(false)}
          >
            {labels.NO}
          </button>
        </Modal>
      ) : null}
    </>
  );
};

export default PaymentOptionForAndroid;
